import axios from './http'; 


const test = (params)=> {
    return axios.post('/api/Data/GetTestingService', params);
}
const index = (params)=> {
    return axios.post('/api/Data/GetIndexInfo', params);
}
const about = (params)=> {
    return axios.post('/api/Data/GetCompanyIntroduction', params);
}
const leader = (params)=> {
    return axios.post('/api/Data/GetLeaders', params);
}
const honor = (params)=> {
    return axios.post('/api/Data/GetHonorList', params);
}

const contact = (params)=> {
    return axios.post('/api/Data/GetCompanyInfoList', params);
}

const rearch = (params)=> {
    return axios.post('/api/Data/GetContentList', params);
}

const topNewsList = (params)=> {
    return axios.post('/api/Data/GetTopNewsList', params);
}

const contentDetailInfo = (params)=> {
    return axios.post('/api/Data/GetContentDetailInfo', params);
}

const newsList = (params)=> {
    return axios.post('/api/Data/GetNewsList', params);
}

const fileList = (params)=> {
    return axios.post('/api/Data/GetFileList', params);
}

const videoList = (params)=> {
    return axios.post('/api/Data/GetVideoList', params);
}

const bookList = (params)=> {
    return axios.post('/api/Data/GetEnterpriseJournalList', params);
}

const stock = (params)=> {
    return axios.post('/api/Data/GetShareInfo', params);
}

const talent = (params)=> {
    return axios.post('/api/Data/GetTalentConceptInfo', params);
}

const university = (params)=> {
    return axios.post('/api/Data/GetPartnerUniversities', params);
}

const job = (params)=> {
    return axios.post('/api/Data/GetJobInfoList', params);
}

const partners = (params)=> {
    return axios.post('/api/Data/GetPartners', params);
}

const search = (params)=> {
    return axios.post('/api/Data/SearchNewsList', params);
}

const banner = (params)=> {
    return axios.post('/api/Data/GetBannarInfo', params);
}

const pageCon = (params)=> {
    return axios.post('/api/Data/GetPageContentInfo', params);
}

const culture = (params)=> {
    return axios.post('/api/Data/GetCompanyCultureInfo', params);
}

const footer = (params)=> {
    return axios.post('/api/Data/GetPageFooterInfo', params);
}

const productList = (params)=> {
    return axios.post('/api/Data/GetProductList', params);
}

const getProductIntroduce = (params)=> {
    return axios.post('/api/Data/GetProductIntroduce', params);
}

const openaApi = (params)=> {
    return axios.post('/api/Data/LockPage', params);
}
const jcList = (params)=> {
    return axios.post('/api/Data/GetTestingServiceInfo', params);
}
const applyList = (params)=> {
    return axios.post('/api/Data/GetContentList', params);
}
const deveList = (params)=> {
    return axios.post('/api/Data/GetDevelopmentInfoList', params);
}
const getMenu = (params)=> {
    return axios.post('/api/Data/GetMenuNames', params);
}
const GetTestingList = (params)=> {
    return axios.post('/api/Data/GetTestingList', params);
}
export default {
    test,
    index,
    about,
    leader,
    honor,
    contact,
    rearch,
    topNewsList,
    contentDetailInfo,
    newsList,
    fileList,
    videoList,
    bookList,
    stock,
    talent,
    university,
    job,
    partners,
    search,
    banner,
    pageCon,
    culture,
    footer,
    productList,
    getProductIntroduce,
    openaApi,
    jcList,
    applyList,
    deveList,
    getMenu,
    GetTestingList
}